import { render } from "./ApplicationForm.vue?vue&type=template&id=0a48b89b&ts=true"
import script from "./ApplicationForm.vue?vue&type=script&lang=ts"
export * from "./ApplicationForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__